var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3, _react_refresh_temp_4;
_react_refresh_temp_3 = $RefreshSig$();
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { WorkspaceLoginMfaRequirement, WorkspaceMfaRequirement, } from '@lucidlink/dto/validation';
import { useToastService } from '@lucidlink/uicore';
import { useAuthProvider } from '#context';
import { useGetWorkspaceLoginStatus, useUserWorkspaces } from '#query-hooks';
import { getTwoFactorAuthenticationToast, getTwoFactorAuthenticationToastId, } from '#services';
const TwoFactorAuthenticationToast = ({ workspace, }) => {
    _react_refresh_temp_3();
    const { id, mfaRequirement, name } = workspace;
    const { addToast, removeToast } = useToastService();
    const { 
    // loginStatus required for the case where workspace mfaRequirement is onNextLogin
    // but by the workspaceLoginStatus status it's derived that this is already the next login
    query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(id);
    useEffect(() => {
        const isOnNextLogin = WorkspaceMfaRequirement.ON_NEXT_LOGIN === mfaRequirement;
        const isMfaRequired = WorkspaceMfaRequirement.REQUIRED === mfaRequirement;
        // Checking whether onNextLogin criteria has passed -
        // case where this is already the second login where MFA is now required
        const derivedMfaRequirement = isOnNextLogin &&
            workspaceLoginStatus?.mfaRequirement ===
                WorkspaceLoginMfaRequirement.REQUIRED
            ? WorkspaceMfaRequirement.REQUIRED
            : mfaRequirement;
        const toastId = getTwoFactorAuthenticationToastId(derivedMfaRequirement, id);
        if (isOnNextLogin || isMfaRequired) {
            addToast(getTwoFactorAuthenticationToast({
                toastId,
                workspaceData: {
                    mfaRequirement: derivedMfaRequirement,
                    name,
                },
                onButtonClick: () => removeToast(toastId),
            }));
        }
        return () => removeToast(toastId);
    }, [
        addToast,
        id,
        mfaRequirement,
        name,
        removeToast,
        workspaceLoginStatus?.mfaRequirement,
    ]);
    return null;
};
_react_refresh_temp_1 = TwoFactorAuthenticationToast;
$RefreshReg$(_react_refresh_temp_1, "TwoFactorAuthenticationToast");
_react_refresh_temp_3(TwoFactorAuthenticationToast, "LI0hT4EKTFipJkSNhab2WbFQ0KE=", false, () => [useToastService, useGetWorkspaceLoginStatus]);
export const TwoFactorAuthenticationToasts = () => {
    _react_refresh_temp_4();
    const { currentUser } = useAuthProvider();
    const { query: { data: workspaces }, } = useUserWorkspaces();
    if (currentUser?.hasCompletedMfa) {
        return null;
    }
    return (workspaces ?? []).map((workspace) => (_jsx(TwoFactorAuthenticationToast, { workspace: workspace }, workspace.id)));
};
_react_refresh_temp_2 = TwoFactorAuthenticationToasts;
$RefreshReg$(_react_refresh_temp_2, "TwoFactorAuthenticationToasts");
_react_refresh_temp_4(TwoFactorAuthenticationToasts, "uyXUccyZYBaNr+6qUPHQsQGLyX4=", false, () => [useAuthProvider, useUserWorkspaces]);
